var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4:5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 4.5,
    width: 18.2,
    height: 23,
    rx: 3.5,
    ry: 3.5,
    stroke: "#1f2830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 17.11h-2.54v-.75l2.19-3.37h1.29v3.3h.71v.82h-.71v1.21h-.94v-1.21Zm-1.62-.82h1.62v-2.46l-1.62 2.46ZM15.95 14.4c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56Zm0 2.89c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56ZM17.92 16.95c.36.41.84.63 1.44.63.67 0 1.1-.42 1.1-.94 0-.58-.42-.95-1.07-.95-.46 0-.83.14-1.17.46l-.66-.19v-2.98h3.49v.82h-2.56v1.54c.26-.26.7-.46 1.21-.46.9 0 1.7.63 1.7 1.72s-.84 1.81-2.03 1.81c-.92 0-1.55-.31-1.98-.82l.54-.64Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop45);
export default __webpack_public_path__ + "static/media/crop-4-5.99bc5556d41299899d86ef4089195245.svg";
export { ForwardRef as ReactComponent };